/** @module components/choice-quiz */


import View from '@lernetz/ts-lib/src/core/view/View';
import {Toggle as template} from '../../templates/choice-quiz';


/**
 * A [View](https://ts-lib.beta.lernetz.site/classes/_core_view_view_.view.html) that renders a toggle; for instance, a check box, a radio button,
 * or anything else with two distinct visual states.
 */
export class ToggleView extends View<boolean> {

    /**
     * Initializes a new instance of the `ToggleView` class.
     *
     * @param checkedTemplate The template to render when `data` is truthy.
     * @param uncheckedTemplate The template to render when `data` is falsy.
     */
    public constructor(private readonly checkedTemplate: string, private readonly uncheckedTemplate: string) {
        super({ template });
    }

    /**
     * @ignore
     * @inheritdoc
     */
    init(): void {
        this.update();
    }

    /**
     * @ignore
     * @inheritdoc
     */
    update(): void {
        if (!this.node) return;

        this.node.innerHTML = this.data ? this.checkedTemplate : this.uncheckedTemplate;
    }
}
